export const DASHBOARD = '/'
export const LOGIN = "/login"
export const SIGN_UP = '/signup'
export const HOME = "/home"
export const CART = '/cart'
export const ORDERS = '/orders'
export const PRODUCTDETAILS = '/product-details/:proId'